export default "__VITE_ASSET__BWextwg2__"